import { render, staticRenderFns } from "./PortfolioEdit.vue?vue&type=template&id=d8e670b8&scoped=true"
import script from "./PortfolioEdit.vue?vue&type=script&lang=js"
export * from "./PortfolioEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e670b8",
  null
  
)

export default component.exports